import * as yup from 'yup';
import useValidators from 'components/Form/validations/useValidators';

const useValidationSchema = (maxLength: number) => {
  const { required, integer, positive, number, max, min } = useValidators();

  const FormSchema = yup.object().shape({
    pin: min(required(yup.string()), 4, 'minLength234'),
    validityDays: max(
      integer(positive(number(yup.number(), 'positiveWithoutZero'))),
      maxLength,
      'maxLengthNumber',
    ),
  });

  return {
    FormSchema,
  };
};

export default useValidationSchema;
